<template>
    <div class="header">
      <div class="header-logo">
        <router-link to="/home">
          <img src="~assets/common/logo-300-150.png"/>
        </router-link>
      </div>
      <div class="header-lang">
        <!--<el-button type="default" class="sw-lang" @click="changeLocale">{{$t("header.lang")}}</el-button>-->
        <el-button type="default" class="sw-lang" @click="$store.commit('changeLang');changeLocale()">{{$t("header.lang")}}</el-button>
      </div>
    </div>
</template>

<script>
export default {
  name: 'Header',
  data () {
    return {
    }
  },
  methods: {
    // 切换语言
    changeLocale () {
      let locale = this.$i18n.locale
      locale === 'zh' ? this.$i18n.locale = 'tw' : this.$i18n.locale = 'zh'
    }
  },
  created () {
  }
}
</script>

<style scoped lang="stylus">
  @import "~styles/varibles"
  img
    width 100%
  .header
    display flex
    height 150px
    padding 0 10.9%
    color $darkTextColor
    justify-content space-between
    align-items center
    .header-logo
      width 300px
    .header-lang
      .sw-lang
        font-size 12px
</style>



// WEBPACK FOOTER //
// src/common/header/Header.vue